<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QKHWFp/images/9781523088225.jpg?1697492690388" alt="This image is the cover for the book 5 Disciplines of Inclusive Leaders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">5 Disciplines of Inclusive Leaders
      </h1>
      <p class="bookDescription body article font2">
        <b>Diversity initiatives are falling short. This book shows leaders how to develop the skills needed to build sustainably inclusive organizations using a tested, research-based model developed by the global organizational consulting firm Korn Ferry. </b><br/><br/>According to the journal <i>Human Resource Management</i>, companies are spending over $8 billion a year on diversity programs. Yet today, the senior leadership teams at Fortune 500 companies are far from mirroring the diversity of its workforce and its customers. Andr&amp;eacute;s Tapia and Alina Polonskaia, senior leaders at Korn Ferry, argue that to build sustainable diversity and inclusion, organizations need to have inclusive leaders at all levels.<br/><br/>In this book, Tapia and Polonskaia draw on Korn Ferry's massive database of 3 million leadership assessments to reveal the essential qualities of inclusive leaders. They discuss the personality traits these leaders share and detail how to develop what they call the five disciplines of inclusive leadership: building interpersonal trust, integrating diverse perspectives, optimizing talent, applying an adaptive mindset, and achieving transformation. <br/><br/>Tapia and Polonskaia also outline the competencies behind each discipline, describe individual and organizational exemplars of inclusive leadership, and show how the five disciplines enable leaders to unleash the power of all people and to build both structurally and behaviorally inclusive organizations. This book will help leaders foster the skills to deal with today's complex challenges and create a more inclusive, sustainable, and prosperous future for all of us.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrés T Tapia, Alina Polonskaia, Kevin Cashman
      </h2>
      
      <p class="authorDescription body article">Andrés Tapia is a senior client partner and diversity and inclusion global strategist at Korn Ferry. He has twenty-five years of consulting experience with Global 500 organizations as well as non-US multinationals in Brazil, South Korea, and India and across Latin America. He is also the author of The Inclusion Paradox and Autntico: The Definitive Guide to Latino Career Success. Alina Polonskaia is a senior client partner and global diversity and inclusion solutions leader at Korn Ferry. She serves as a trusted advisor to Fortune 1000 organizations across various industries and geographies.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f01d47e